import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationServiceProviderLookup extends ModelBase {

    public organisationServiceProviderId: number = 0;

    public organisationId: number = 0;

    public staticServiceProviderId: number = 0;

    public organisationName: string = "";

    public serviceProviderName: string = "";
}